import React, { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import {
    deleteFutureCustomer,
    exportFutureCustomer,
    getDropDownMaster,
    getFutureCustomer,
    searchFutureCustomer,
    updateFutureCustomer,
} from "../../../services/customerFutures";
import { masterDataFuture } from "../../customer/touchpoint/components/dataReport";
import { SearchUserContext } from "../future/searchContext";
import Search from "./components/search";
import TableListdata from "./components/tableList";
import axios from "axios";
import { APPCONFIG } from "../../../Config";
import { ACCESS_TOKEN, SUCCESS_CODE } from "../../../lib/const";
import APIEndpoint from "../../../services/endpoint";
import FileSaver from "file-saver";
import useYearFilterBC from "../../../lib/hooks/useYearsFilterBC";

const dateFormat = "DD/MM/YYYY";
export const convertMasterData = (keytext, data) => {
    let text = "";
    data.map((Item) => {
        if (Item.dataId === keytext) {
            text = Item.dataDetailTh;
        }
    });
    return text;
};

const FutureCustomer = () => {
    const { searchValues, setSearchValues, pageValues, setPageValues, search, setSearch } = useContext(SearchUserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [permissionView, setPerssionView] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [modalText, setModalText] = useState("คุณต้องการลบข้อมูล ?");
    const [successModal, setSuccessModal] = useState(false);
    const [failModal, setFailModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dropDownCurerntStatus, setDropDownCurerntStatus] = useState([]);
    const [dropDownCompanyType, setDropDownCompanyType] = useState([
        {
            dataId: "",
            dataDetailEn: "select all",
            dataDetailTh: "เลือกทั้งหมด",
            dataTopic: "company_type",
        },
    ]);
    const [dropDownIndustryType, setDropDownIndustryType] = useState([
        {
            dataId: "",
            dataDetailEn: "select all",
            dataDetailTh: "เลือกทั้งหมด",
            dataTopic: "company_type",
        },
    ]);
    const [dropDownAreaType, setDropDownAreaType] = useState([
        {
            dataId: "",
            dataDetailEn: "select all",
            dataDetailTh: "เลือกทั้งหมด",
            dataTopic: "company_type",
        },
    ]);
    const [dropDownKnowChannel, setDropDownKnowChannel] = useState([
        {
            dataId: "",
            dataDetailEn: "select all",
            dataDetailTh: "เลือกทั้งหมด",
            dataTopic: "company_type",
        },
    ]);
    const [dropDownRegionGroup, setDropDownRegionGroup] = useState([
        {
            dataId: "",
            dataDetailEn: "select all",
            dataDetailTh: "เลือกทั้งหมด",
            dataTopic: "company_type",
        },
    ]);
    const [dropDownPurpost, setDropDownPurpost] = useState([
        {
            dataId: "",
            dataDetailEn: "select all",
            dataDetailTh: "เลือกทั้งหมด",
            dataTopic: "company_type",
        },
    ]);
    const [id, setId] = useState("");
    const [dataSource, setDataSource] = useState([]);

    const [oldSeleted, setOldSeleted] = useState("");

    const [fetchData, setFetchData] = useState(true);
    const [waterLower, setWaterLower] = useState("");
    const [waterUpper, setWaterUpper] = useState("");
    const [areaLower, setAreaLower] = useState("");
    const [areaUpper, setAreaUpper] = useState("");
    const [electLower, setElectLower] = useState("");
    const [electUpper, setElectUpper] = useState("");
    const [wastLower, setWastLower] = useState("");
    const [wastUpper, setWastUpper] = useState("");
    const [optionsYear, setOptionYear] = useState([]);

    const [areaSizeByRaiMin, setAreaSizeByRaiMin] = useState("");
    const [areaSizeByRaiMax, setAreaSizeByRaiMax] = useState("");

    const [areaSizeByNganMin, setAreaSizeByNganMin] = useState("");
    const [areaSizeByNganMax, setAreaSizeByNganMax] = useState("");

    const [areaSizeByWaMin, setAreaSizeByWaMin] = useState("");
    const [areaSizeByWaMax, setAreaSizeByWaMax] = useState("");

    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");

    let [no, setNo] = useState(0);
    const [yearList] = useYearFilterBC();

    const [confirmModal, setConfirmModal] = useState({
        type: "",
        show: false,
        id: 0,
        status_name: "",
    });

    // role user : permision
    const [roleUser, isAdmin] = usePermission(PERMISSION_DATA.APPLICATION, PAGES.FUTURE_CUSTOMER);

    useEffect(() => {
        setPerssionView(roleUser[0]?.isView);
    }, [permissionView]);

    const onChangeStatusTable = async (value, record) => {
        const res = await getFutureCustomer(confirmModal.id);
        let chkStatus = convertMasterData(confirmModal.status, dropDownCurerntStatus);

        if (res.data.code === "0000") {
            let result_data = res.data.objectValue;

            let requestbody = {
                requestObject: {
                    futureCustomerId: confirmModal.id,
                    dbdRegisterNumber: result_data.dbdRegisterNumber,
                    yearOfBudget: parseInt(result_data.yearOfBudget),
                    fromDate: result_data.fromDate,
                    toDate: result_data.toDate,
                    currentStatus: confirmModal.status,
                    isToCurrentCustomer: chkStatus === "ปิดการขาย (ส่งสู่ลูกค้าปัจจุบัน)" ? true : false,
                    isInvestmentAdvice: result_data.isAskForApprove != null ? result_data.isAskForApprove : null,
                    isVisitAreaLandInfo: result_data.isVisitAreaLandInfo != null ? result_data.isVisitAreaLandInfo : null,
                    isAskForApprove: result_data.isAskForApprove != null ? result_data.isAskForApprove : null,
                    otherPurposes: result_data.otherPurposes,
                    companyType: result_data.companyType,
                    companyNameEn: result_data.companyNameEn,
                    companyNameTh: result_data.companyNameTh,
                    address: result_data.address,
                    website: result_data.website,
                    nationalIds: result_data.nationalIds,
                    currentIndustry: result_data.currentIndustry,
                    ieatIndusrty: result_data.ieatIndusrty,
                    industryTypeIds: result_data.industryTypeIds,
                    investmentAmount: result_data.investmentAmount ? parseFloat(result_data.investmentAmount) : 0.0,
                    areaTypeIds: result_data.areaTypeIds,
                    areaSizeRai: result_data.areaSizeRai ? parseFloat(result_data.areaSizeRai) : 0.0,
                    areaSizeNgan: result_data.areaSizeNgan ? parseFloat(result_data.areaSizeNgan) : 0.0,
                    areaSizeWa: result_data.areaSizeWa ? parseFloat(result_data.areaSizeWa) : 0.0,
                    areaSizeMeter: result_data.areaSizeMeter ? parseFloat(result_data.areaSizeMeter) : 0.0,
                    areaSizeRecommend: result_data.areaSizeRecommend ? parseFloat(result_data.areaSizeRecommend) : 0.0,
                    waterConsumptionAmount: result_data.waterConsumptionAmount ? parseFloat(result_data.waterConsumptionAmount) : 0.0,
                    wasteWaterAmount: result_data.wasteWaterAmount ? parseFloat(result_data.wasteWaterAmount) : 0.0,
                    kwAmount: result_data.kwAmount ? parseFloat(result_data.kwAmount) : 0.0,
                    futureCustomerMembers: result_data.futureCustomerMembers,
                    futureCustomerVoc: result_data.futureCustomerVoc,
                    futureCustomerBehavior: result_data.futureCustomerBehavior,
                    futureCustomerContacts: result_data.futureCustomerContacts,
                },
            };

            //   console.log("Edit=> ", requestbody);
            try {
                const res = await updateFutureCustomer(requestbody);
                if (res.data.code === "0000") {
                    setSuccessModal(true);
                    setSearch(true);
                } else {
                    setFailModal(true);
                }
            } catch (error) {
                //  console.log(error);
            }
        }
        setConfirmModal({
            type: "",
            show: false,
            id: 0,
            status_name: "",
            old_data: confirmModal.old_data,
        });
    };

    const onChangeRangePicker = (value, e) => {
        if (!value) {
            setDateFrom("");
            setDateTo("");
            return;
        }
        setDateFrom(value[0].format(dateFormat));
        setDateTo(value[1].format(dateFormat));
    };

    const getMaster = useCallback(
        async (toppicKey) => {
            try {
                const res = await getDropDownMaster(toppicKey);
                if (res.data.code === "0000") {
                    let result_data = res.data.objectValue;

                    if (toppicKey == "current_status_v2") {
                        setDropDownCurerntStatus(result_data);
                    } else if (toppicKey == "company_type") {
                        result_data.map((item) => {
                            dropDownCompanyType.push(item);
                        });
                    } else if (toppicKey == "industry_type") {
                        //  setDropDownIndustryType(result_data);
                        result_data.map((item) => {
                            dropDownIndustryType.push(item);
                        });
                    } else if (toppicKey == "area_type") {
                        result_data.map((item) => {
                            dropDownAreaType.push(item);
                        });
                        //  setDropDownAreaType(result_data);
                    } else if (toppicKey == "known_channel") {
                        result_data.map((item) => {
                            dropDownKnowChannel.push(item);
                        });
                        //  setDropDownKnowChannel(result_data);
                    } else if (toppicKey == "region_group") {
                        result_data.map((item) => {
                            dropDownRegionGroup.push(item);
                        });
                        //setDropDownRegionGroup(result_data);
                    } else if (toppicKey == "purpose_contact") {
                        result_data.map((item) => {
                            dropDownPurpost.push(item);
                        });
                        //setDropDownPurpost(result_data);
                    }
                }
            } catch (error) {
                // console.log("error==>", error);
            }
        },
        [dropDownCurerntStatus]
    );

    const fetchFutureCustomers = useCallback(
        async (searchValues, pageValues) => {
            const res = await searchFutureCustomer(searchValues, pageValues);
            const { objectValue, pageValue } = res.data;

            if (res?.data?.code === "0000") {
                let _p = parseInt(pageValues.page) === 0 ? parseInt(pageValues.page) : parseInt(pageValues.page) * pageValues.pageSize;
                setNo(_p);
                setDataSource(objectValue);
                setPageValues(pageValue);
            } else {
                setDataSource([]);
            }
        },
        [setDataSource, setSearchValues, setPageValues]
    );

    const onSearch = async (values) => {
        let checkListYear = "";
        if (values.yearOfBudgets) {
            values.yearOfBudgets.map((item) => {
                if (item === "") {
                    checkListYear = null;
                }
            });
        }

        let checkCompanyType = "";
        if (values.companyType) {
            values.companyType.map((item) => {
                if (item === "") {
                    checkCompanyType = null;
                }
            });
        }

        let checkNationalityList = "";
        if (values.nationalityList) {
            values.nationalityList.map((item) => {
                if (item === "") {
                    checkNationalityList = null;
                }
            });
        }

        let checkIndustryType = "";
        if (values.industryType) {
            values.industryType.map((item) => {
                if (item === "") {
                    checkIndustryType = null;
                }
            });
        }

        let checkAreaType = "";
        if (values.areaType) {
            values.areaType.map((item) => {
                if (item === "") {
                    checkAreaType = null;
                }
            });
        }

        let checkChannels = "";
        if (values.channels) {
            values.channels.map((item) => {
                if (item === "") {
                    checkChannels = null;
                }
            });
        }

        let valueIsInvestmentAdvice = null;
        let valueIsVisitAreaLandInfo = null;

        //check search
        if (values.isInvestmentAdvice) {
            values.isInvestmentAdvice.map((item) => {
                if (item === "") {
                    valueIsInvestmentAdvice = true;
                    valueIsVisitAreaLandInfo = true;
                }
            });

            if (
                (values.isInvestmentAdvice[0] === "6a63c1b8-dbce-4398-ad5f-21bc3d438454" &&
                    values.isInvestmentAdvice[1] === "ca2e0eed-f665-4f3d-8ba2-6a1d293e334b") ||
                (values.isInvestmentAdvice[0] === "ca2e0eed-f665-4f3d-8ba2-6a1d293e334b" &&
                    values.isInvestmentAdvice[1] === "6a63c1b8-dbce-4398-ad5f-21bc3d438454")
            ) {
                valueIsInvestmentAdvice = true;
                valueIsVisitAreaLandInfo = true;
            } else if (values.isInvestmentAdvice[0] === "6a63c1b8-dbce-4398-ad5f-21bc3d438454") {
                valueIsInvestmentAdvice = true;
                valueIsVisitAreaLandInfo = null;
            } else if (values.isInvestmentAdvice[0] === "ca2e0eed-f665-4f3d-8ba2-6a1d293e334b") {
                valueIsInvestmentAdvice = null;
                valueIsVisitAreaLandInfo = true;
            }
        }

        setSearch(true);
        setSearchValues({
            yearOfBudgets: checkListYear === null ? [] : values.yearOfBudgets ? values?.yearOfBudgets : [],
            companyType: checkCompanyType === null ? [] : values.companyType ? values?.companyType : [],
            nationalityList: checkNationalityList === null ? [] : values.nationalityList ? values?.nationalityList : [],
            industryType: checkIndustryType === null ? [] : values.industryType ? values?.industryType : [],
            countryList: values?.customerRegion || [],
            statusList: values?.currentStatus || [],
            companyName: values?.companyName || "",
            contactName: values?.contactName || "",
            contactDateFrom: dateFrom != "" ? dateFrom : "",
            contactDateTo: dateTo != "" ? dateTo : "",
            areaSizeByRaiMin: areaSizeByRaiMin != "" ? areaSizeByRaiMin : "",
            areaSizeByRaiMax: areaSizeByRaiMax != "" ? areaSizeByRaiMax : "",
            areaSizeByNganMin: areaSizeByNganMin != "" ? areaSizeByNganMin : "",
            areaSizeByNganMax: areaSizeByNganMax != "" ? areaSizeByNganMax : "",
            areaSizeByWaMin: areaSizeByWaMin != "" ? areaSizeByWaMin : "",
            areaSizeByWaMax: areaSizeByWaMax != "" ? areaSizeByWaMax : "",
            areaSizeByMetersMax: areaUpper != "" ? areaUpper : "",
            areaSizeByMetersMin: areaLower != "" ? areaLower : "",
            waterConsumptionMin: waterLower != "" ? waterLower : "",
            waterConsumptionMax: waterUpper != "" ? waterUpper : "",
            wasteWaterMin: wastLower != "" ? wastLower : "",
            wasteWaterMax: wastUpper != "" ? wastUpper : "",
            kwMin: electLower != "" ? electLower : "",
            kwMax: electUpper != "" ? electUpper : "",
            areaType: checkAreaType === null ? [] : values.areaType ? values?.areaType : [],
            isInvestmentAdvice: valueIsInvestmentAdvice === null ? null : valueIsInvestmentAdvice === true ? true : null,
            isVisitAreaLandInfo: valueIsVisitAreaLandInfo === null ? null : valueIsVisitAreaLandInfo === true ? true : null,
            channels: checkChannels === null ? [] : values.channels ? values?.channels : [],
            futureCustomerId: values?.futureCustomerId || ""
        });

        setPageValues({
            page: 0,
            pageSize: pageValues.pageSize,
            total: pageValues.total,
            totalPage: pageValues.totalPage,
            sortBy: pageValues.sortBy,
            sortDirection: pageValues.sortDirection,
        });
    };

    const onActionDelete = async (id) => {
        setConfirmLoading(true);
        setOpenModal(true);
        setConfirmLoading(false);
        setId(id);
    };

    const handleOk = async () => {
        setConfirmLoading(true);
        setOpenModal(false);
        setConfirmLoading(false);

        try {
            const res = await deleteFutureCustomer(id);
            if (res.data.code === "0000") {
                setSuccessModal(true);
                // setFetchData(true);
                setSearch(true);
            } else {
                setFailModal(true);
            }
        } catch (error) {}
    };

    const handleCancel = () => {
        setOpenModal(false);
    };

    const handleChangeInputNumber = (e, type) => {
        if (type.includes("water")) {
            if (type === "waterLower") {
                setWaterLower(e);
            } else {
                setWaterUpper(e);
            }
        }
        if (type.includes("elect")) {
            if (type === "electLower") {
                setElectLower(e);
            } else {
                setElectUpper(e);
            }
        }
        if (type.includes("wast")) {
            if (type === "wastLower") {
                setWastLower(e);
            } else {
                setWastUpper(e);
            }
        }
        if (type.includes("areaMaster")) {
            if (type === "areaMasterLower") {
                setAreaLower(e);
            } else {
                setAreaUpper(e);
            }
        }
        if (type.includes("areaSizeByRai")) {
            if (type === "areaSizeByRaiMin") {
                setAreaSizeByRaiMin(e);
            } else {
                setAreaSizeByRaiMax(e);
            }
        }
        if (type.includes("areaSizeByNgan")) {
            if (type === "areaSizeByNganMin") {
                setAreaSizeByNganMin(e);
            } else {
                setAreaSizeByNganMax(e);
            }
        }
        if (type.includes("areaSizeByWa")) {
            if (type === "areaSizeByWaMin") {
                setAreaSizeByWaMin(e);
            } else {
                setAreaSizeByWaMax(e);
            }
        }
    };

    const onExportFile = async () => {
        const api = APIEndpoint.EXPORT_FUTURE;
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
                "content-type": "application/json",
            },
            responseType: "blob",
        };
        let payload = {
            requestObject: {
                yearOfBudgets: searchValues.yearOfBudgets ? searchValues?.yearOfBudgets : [],
                companyType: searchValues.companyType ? searchValues.companyType : [],
                nationalityList: searchValues.nationalityList ? searchValues.nationalityList : [],
                industryType: searchValues.industryType ? searchValues.industryType : [],
                contactDateFrom: searchValues.contactDateFrom ? searchValues.contactDateFrom : "",
                contactDateTo: searchValues.contactDateTo ? searchValues.contactDateTo : "",
                areaSizeByRaiMin: searchValues.areaSizeByRaiMin ? searchValues.areaSizeByRaiMin : "",
                areaSizeByRaiMax: searchValues.areaSizeByRaiMax ? searchValues.areaSizeByRaiMax : "",
                areaSizeByNganMin: searchValues.areaSizeByNganMin ? searchValues.areaSizeByNganMin : "",
                areaSizeByNganMax: searchValues.areaSizeByNganMax ? searchValues.areaSizeByNganMax : "",
                areaSizeByWaMin: searchValues.areaSizeByWaMin ? searchValues.areaSizeByWaMin : "",
                areaSizeByWaMax: searchValues.areaSizeByWaMax ? searchValues.areaSizeByWaMax : "",
                areaSizeByMetersMax: searchValues.areaSizeByMetersMax ? searchValues.areaSizeByMetersMax : "",
                areaSizeByMetersMin: searchValues.areaSizeByMetersMin ? searchValues.areaSizeByMetersMin : "",
                waterConsumptionMin: searchValues.waterConsumptionMin ? searchValues.waterConsumptionMin : "",
                waterConsumptionMax: searchValues.waterConsumptionMax ? searchValues.waterConsumptionMax : "",
                wasteWaterMin: searchValues.wasteWaterMin ? searchValues.wasteWaterMin : "",
                wasteWaterMax: searchValues.wasteWaterMax ? searchValues.wasteWaterMax : "",
                kwMin: searchValues.kwMin ? searchValues.kwMin : "",
                kwMax: searchValues.kwMax ? searchValues.kwMax : "",
                areaType: searchValues.areaType ? searchValues.areaType : [],
                isInvestmentAdvice: searchValues.isInvestmentAdvice,
                isVisitAreaLandInfo: searchValues.isVisitAreaLandInfo,
                channels: searchValues.channels ? searchValues.channels : [],
            },
        };

        const res = await axios.post(APPCONFIG.GATEWAY_ENDPOINT + api, payload, config);
        if (res.data) {
            let blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver.saveAs(blob, "ข้อมูลลูกค้าอนาคต.xlsx");
        } else {
        }
    };

    const onSorter = (pagination, filters, sorter) => {
        setSearch(true);
        setPageValues((prev) => ({
            ...prev,
            sortBy: sorter && sorter.order ? sorter.columnKey : "yearOfBudget",
            sortDirection: sorter && sorter.order ? (sorter.order === "ascend" ? "ASC" : "DESC") : "ASC",
        }));
    };

    const onPageChange = (page, pageSize) => {
        setSearch(true);
        setPageValues((prev) => ({
            ...prev,
            page: page - 1,
            pageSize: pageSize,
        }));
    };

    useEffect(() => {
        if (search) {
            fetchFutureCustomers(searchValues, pageValues);
            setSearch(false);
        }
    }, [fetchFutureCustomers, searchValues, pageValues, search, setSearch]);

    useEffect(() => {
        masterDataFuture.map((item) => {
            getMaster(item);
        });
    }, []);

    return (
        <>
            <Search
                id={id}
                yearList={yearList}
                onSearch={onSearch}
                handleChangeInputNumber={handleChangeInputNumber}
                dropDownCompanyType={dropDownCompanyType}
                dropDownIndustryType={dropDownIndustryType}
                dropDownAreaType={dropDownAreaType}
                dropDownRegionGroup={dropDownRegionGroup}
                dropDownPurpost={dropDownPurpost}
                dropDownKnowChannel={dropDownKnowChannel}
                onChangeRangePicker={onChangeRangePicker}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                onExportFile={onExportFile}
                setWaterLower={setWaterLower}
                setWaterUpper={setWaterUpper}
                waterLower={waterLower}
                waterUpper={waterUpper}
                setAreaLower={setAreaLower}
                setAreaUpper={setAreaUpper}
                areaLower={areaLower}
                areaUpper={areaUpper}
                setElectLower={setElectLower}
                setElectUpper={setElectUpper}
                electLower={electLower}
                electUpper={electUpper}
                setWastLower={setWastLower}
                setWastUpper={setWastUpper}
                wastLower={wastLower}
                wastUpper={wastUpper}
                setAreaSizeByRaiMin={setAreaSizeByRaiMin}
                setAreaSizeByRaiMax={setAreaSizeByRaiMax}
                areaSizeByRaiMin={areaSizeByRaiMin}
                areaSizeByRaiMax={areaSizeByRaiMax}
                setAreaSizeByNganMin={setAreaSizeByNganMin}
                setAreaSizeByNganMax={setAreaSizeByNganMax}
                areaSizeByNganMin={areaSizeByNganMin}
                areaSizeByNganMax={areaSizeByNganMax}
                setAreaSizeByWaMin={setAreaSizeByWaMin}
                setAreaSizeByWaMax={setAreaSizeByWaMax}
                areaSizeByWaMin={areaSizeByWaMin}
                areaSizeByWaMax={areaSizeByWaMax}
                roleUser={roleUser}
            />
            <TableListdata
                dataSource={dataSource}
                setOpenModal={setOpenModal}
                permissionView={permissionView}
                isAdmin={isAdmin}
                dropDownCurerntStatus={dropDownCurerntStatus}
                onDelete={onActionDelete}
                onChangeStatusTable={onChangeStatusTable}
                setConfirmModal={setConfirmModal}
                onSorter={onSorter}
                onPageChange={onPageChange}
                oldSeleted={oldSeleted}
                no={no}
                roleUser={roleUser}
            ></TableListdata>
            <ConfirmModal
                title={"ยืนยันการลบข้อมูล"}
                open={openModal}
                modalText={modalText}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                actionType={"delete"}
            />
            <ConfirmModal
                actionType={""}
                title={"ยืนยันการเปลี่ยนสถานะ"}
                modalText={"คุณต้องการเปลี่ยนสถานะเป็น " + convertMasterData(confirmModal.status, dropDownCurerntStatus) + " ใช่ไหม ?"}
                open={confirmModal.type === "change_status" ? confirmModal.show : false}
                onOk={() => {
                    onChangeStatusTable();
                }}
                onCancel={() => {
                    setConfirmModal({
                        type: "",
                        show: false,
                        id: 0,
                        status_name: "",
                        old_data: confirmModal.old_data,
                    });
                }}
            />
            <SuccessModal open={successModal} setOpen={setSuccessModal} title={"สำเร็จ"} subTitle={"ทำรายการสำเร็จ"} />
            <FailModal open={failModal} setOpen={setFailModal} title={"มีบางอย่างผิดพลาด"} subTitle={"มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"} />
        </>
    );
};

export default FutureCustomer;
